import styled from 'styled-components';
import { rgba } from 'polished';

// COLORS
import { SANTAS_GRAY, WHITE } from '@/constants/colors';

export const Container = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  padding: 5px 17px;
  border-radius: 8px;
  overflow: hidden;
  background-color: ${rgba(SANTAS_GRAY, 0.15)};
  min-height: 56px;

  .key-feature {
    &__title {
      font-weight: 600;
      color: ${WHITE};
    }

    &__icon {
      color: ${p => p.color || p.theme.palette.primary};
      font-size: 29px;
      margin-right: 10px;
    }
  }
`;

export default Container;
